import React from 'react';

import type {IconProp} from '@fortawesome/fontawesome-svg-core';
import {faTrash} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {InlineEditableTable} from '../../../shared/components';
import type {ILiabilitiesInlineTableProps} from '../financials.types';

const iconTrash = faTrash as IconProp;

export const LiabilitiesInlineTable: React.FC<ILiabilitiesInlineTableProps> = ({
  liabilityRows,
  liabilityAccountTypes,
  isSavingLiabilities,
  onUpdateLiabilityRowField,
  onDeleteLiability,
}) => (
  <InlineEditableTable className="financials-liabilities__table-wrap">
    <table className="financials-liabilities-table">
      <thead>
        <tr>
          <th scope="col">Lender</th>
          <th scope="col">Type</th>
          <th scope="col">Credit limit</th>
          <th scope="col">Current balance</th>
          <th scope="col">Monthly installment</th>
          <th scope="col">Status</th>
          <th scope="col" aria-label="Actions" />
        </tr>
      </thead>
      <tbody>
        {liabilityRows.map((row) => (
          <tr key={row.localId}>
            <td>
              <input
                className="money-form-field__control financials-liabilities-table__cell-input"
                type="text"
                value={row.lender}
                onChange={(event) =>
                  onUpdateLiabilityRowField(
                    row.localId,
                    'lender',
                    event.target.value,
                  )
                }
                disabled={isSavingLiabilities}
                placeholder="Lender"
              />
            </td>
            <td>
              <select
                className="money-form-field__control financials-liabilities-table__cell-select"
                value={row.liabilityAccountTypeId ?? ''}
                onChange={(event) =>
                  onUpdateLiabilityRowField(
                    row.localId,
                    'liabilityAccountTypeId',
                    event.target.value,
                  )
                }
                disabled={isSavingLiabilities}
              >
                <option value="">Select type</option>
                {row.liabilityAccountTypeId &&
                !liabilityAccountTypes.some(
                  (type) =>
                    Number(type.id) === Number(row.liabilityAccountTypeId),
                ) ? (
                  <option value={row.liabilityAccountTypeId}>
                    {row.liabilityAccountTypeName || 'Current type'}
                  </option>
                ) : null}
                {liabilityAccountTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.name}
                  </option>
                ))}
              </select>
            </td>
            <td>
              <input
                className="money-form-field__control financials-liabilities-table__cell-input"
                type="text"
                inputMode="decimal"
                value={row.creditLimitAmount}
                onChange={(event) =>
                  onUpdateLiabilityRowField(
                    row.localId,
                    'creditLimitAmount',
                    event.target.value,
                  )
                }
                disabled={isSavingLiabilities}
                placeholder="0.00"
              />
            </td>
            <td>
              <input
                className="money-form-field__control financials-liabilities-table__cell-input"
                type="text"
                inputMode="decimal"
                value={row.currentBalanceLimit}
                onChange={(event) =>
                  onUpdateLiabilityRowField(
                    row.localId,
                    'currentBalanceLimit',
                    event.target.value,
                  )
                }
                disabled={isSavingLiabilities}
                placeholder="0.00"
              />
            </td>
            <td>
              <input
                className="money-form-field__control financials-liabilities-table__cell-input"
                type="text"
                inputMode="decimal"
                value={row.monthlyInstallmentAmount}
                onChange={(event) =>
                  onUpdateLiabilityRowField(
                    row.localId,
                    'monthlyInstallmentAmount',
                    event.target.value,
                  )
                }
                disabled={isSavingLiabilities}
                placeholder="0.00"
              />
            </td>
            <td>
              <select
                className="money-form-field__control financials-liabilities-table__cell-select"
                value={row.inArrears ? 'in-arrears' : 'up-to-date'}
                onChange={(event) =>
                  onUpdateLiabilityRowField(
                    row.localId,
                    'inArrears',
                    event.target.value === 'in-arrears',
                  )
                }
                disabled={isSavingLiabilities}
              >
                <option value="up-to-date">Up to date</option>
                <option value="in-arrears">In arrears</option>
              </select>
            </td>
            <td className="financials-liabilities-table__actions">
              <button
                type="button"
                className="btn btn-tertiary is-danger"
                onClick={() => {
                  onDeleteLiability(row);
                }}
                disabled={isSavingLiabilities}
              >
                <FontAwesomeIcon icon={iconTrash} aria-hidden="true" />
                <span>Delete</span>
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </InlineEditableTable>
);
